import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import { ProtectedRoute } from "./ProtectedRoute";

const ContentRoutes = () => {
	const [menuInfo, setMenuArray] = useState(contents)

	return (
		<Routes>
			{
				menuInfo.map((page) => (
					// <Route key={page.path} {...page} />
					<Route key={page.path} {...page}
						element={
							<ProtectedRoute>
								{page.element}
							</ProtectedRoute>
						}
					/>
				))
			}
		</Routes>
	);
};

export default ContentRoutes;
